import { render, staticRenderFns } from "./self-flow.vue?vue&type=template&id=035648ec&scoped=true"
import script from "./self-flow.vue?vue&type=script&lang=js"
export * from "./self-flow.vue?vue&type=script&lang=js"
import style0 from "./self-flow.vue?vue&type=style&index=0&id=035648ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035648ec",
  null
  
)

export default component.exports